import { gql } from '@apollo/client'

export default gql`
  fragment ContractChangeValidationEntry on ContractChangeValidationEntry {
    date
    salary
    bonus
    nationalContractLevel
    governmentJobTitle {
      hiringOfficeCode
      department
      title
    }
    employeeLevel
  }

  fragment ContractChangeValidationList on ContractChangeValidationList {
    validationEntries {
      ...ContractChangeValidationEntry
    }
  }
`
